import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { isObservable, of, Subject } from 'rxjs';
import { catchError, switchMap, takeUntil } from 'rxjs/operators';
import { SearchBarServiceService } from '../search-bar-service.service';
import { SearchBoxComponent } from '../search-box/search-box.component';

const REFRESH_SPIN_MS = 2500;

@Component({
  selector: 'ngx-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit, OnDestroy {

  @Input() embedded = false;

  @ViewChild('searchBox') searchBox: SearchBoxComponent;

  isRefreshing = false;

  private query$ = new Subject<string>();
  private destroy$ = new Subject<void>();
  private spinTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(public barService: SearchBarServiceService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.query$.pipe(
      // switchMap unsubscribes the previous search, aborting its in-flight request.
      switchMap(query => {
        const result = this.barService.searchButtonListener?.(query);
        return (isObservable(result) ? result : of(null)).pipe(
          catchError(() => of(null)),
        );
      }),
      takeUntil(this.destroy$),
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.clearSpinTimer();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearch(query: string): void {
    this.query$.next(query);
  }

  refreshReferrals(): void {
    this.clearSpinTimer();
    this.isRefreshing = true;
    // Timer-owned, never response-owned: this bar sits in an OnPush toolbar a response-time write would not repaint.
    this.spinTimer = setTimeout(() => {
      this.spinTimer = null;
      this.isRefreshing = false;
      this.cdr.markForCheck();
    }, REFRESH_SPIN_MS);
    this.searchBox.clear();
  }

  private clearSpinTimer(): void {
    if (this.spinTimer === null) {
      return;
    }
    clearTimeout(this.spinTimer);
    this.spinTimer = null;
  }
}
